/* GOWin® Store — actualización quirúrgica del carrito, 2026-08-07 */
(() => {
  'use strict';

  if (window.GowinCartSurgicalUpdateInstalled) return;
  window.GowinCartSurgicalUpdateInstalled = true;

  const UPDATE_ATTR = 'data-gowin-quantity-update';
  const RECOMMENDATIONS_SELECTOR = '.gowin-drawer-shipping__recommendations';
  const VIEWPORT_SELECTOR = '.gowin-drawer-shipping__viewport';
  const DATA_SELECTORS = [
    '[data-gowin-cart-price-data]',
    '[data-gowin-cart-summary-data]',
  ];

  const installStyles = () => {
    if (document.getElementById('gowin-cart-surgical-update-style')) return;

    const style = document.createElement('style');
    style.id = 'gowin-cart-surgical-update-style';
    style.textContent = `
      cart-drawer[${UPDATE_ATTR}] cart-drawer-items {
        scroll-behavior: auto !important;
        overflow-anchor: none !important;
      }

      cart-drawer[${UPDATE_ATTR}] .cart-item__name:focus,
      cart-drawer[${UPDATE_ATTR}] .cart-item__name:focus-visible {
        outline: none !important;
        box-shadow: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const parseSection = (html, selector) => {
    if (typeof html !== 'string' || !html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };

  const copyDataNode = (currentRoot, freshRoot, selector) => {
    const current = currentRoot?.querySelector(selector);
    const fresh = freshRoot?.querySelector(selector);

    if (current && fresh) {
      current.replaceWith(fresh.cloneNode(true));
      return;
    }

    if (!current && fresh) {
      currentRoot.prepend(fresh.cloneNode(true));
      return;
    }

    if (current && !fresh) current.remove();
  };

  const patchShipping = (currentCartItems, freshCartItems, preserveRecommendations) => {
    const currentShipping = currentCartItems?.querySelector('[data-gowin-drawer-shipping]');
    const freshShipping = freshCartItems?.querySelector('[data-gowin-drawer-shipping]');

    if (!currentShipping && freshShipping) {
      currentCartItems.prepend(freshShipping.cloneNode(true));
      return;
    }

    if (currentShipping && !freshShipping) {
      currentShipping.remove();
      return;
    }

    if (!currentShipping || !freshShipping) return;

    currentShipping.className = freshShipping.className;

    const currentStatus = currentShipping.querySelector('.gowin-drawer-shipping__status');
    const freshStatus = freshShipping.querySelector('.gowin-drawer-shipping__status');
    if (currentStatus && freshStatus) currentStatus.replaceWith(freshStatus.cloneNode(true));

    const currentRecommendations = currentShipping.querySelector(RECOMMENDATIONS_SELECTOR);
    const freshRecommendations = freshShipping.querySelector(RECOMMENDATIONS_SELECTOR);

    if (preserveRecommendations && currentRecommendations && freshRecommendations) {
      // Mantener el MISMO nodo evita que el carrusel desaparezca y reaparezca.
      return;
    }

    if (currentRecommendations && freshRecommendations) {
      currentRecommendations.replaceWith(freshRecommendations.cloneNode(true));
    } else if (currentRecommendations && !freshRecommendations) {
      currentRecommendations.remove();
    } else if (!currentRecommendations && freshRecommendations) {
      currentShipping.append(freshRecommendations.cloneNode(true));
    }
  };

  const patchCartRows = (currentCartItems, freshCartItems) => {
    const currentWrapper = currentCartItems?.querySelector('.drawer__cart-items-wrapper');
    const freshWrapper = freshCartItems?.querySelector('.drawer__cart-items-wrapper');

    if (currentWrapper && freshWrapper) {
      currentWrapper.replaceWith(freshWrapper.cloneNode(true));
    } else if (currentWrapper && !freshWrapper) {
      currentWrapper.remove();
    } else if (!currentWrapper && freshWrapper) {
      currentCartItems.append(freshWrapper.cloneNode(true));
    }
  };

  const patchFooter = (drawer, freshInner) => {
    const currentFooter = drawer.querySelector('.drawer__footer .cart-drawer__footer');
    const freshFooter = freshInner.querySelector('.drawer__footer .cart-drawer__footer');
    if (currentFooter && freshFooter) currentFooter.replaceWith(freshFooter.cloneNode(true));

    const currentCheckout = drawer.querySelector('#CartDrawer-Checkout');
    const freshCheckout = freshInner.querySelector('#CartDrawer-Checkout');
    if (currentCheckout && freshCheckout) currentCheckout.disabled = freshCheckout.disabled;
  };

  const patchIconBubble = (state) => {
    const html = state?.sections?.['cart-icon-bubble'];
    if (typeof html !== 'string') return;

    const current = document.getElementById('cart-icon-bubble');
    const freshSection = parseSection(html, '.shopify-section');
    const fresh = freshSection?.querySelector('#cart-icon-bubble');

    if (current && fresh) current.innerHTML = fresh.innerHTML;
  };

  const patchNonEmptyDrawer = (drawer, state, preserveRecommendations) => {
    const sectionHtml = state?.sections?.['cart-drawer'];
    const freshInner = parseSection(sectionHtml, '.drawer__inner');
    const currentItems = drawer.querySelector('cart-drawer-items');
    const currentCartItems = drawer.querySelector('#CartDrawer-CartItems');
    const freshCartItems = freshInner?.querySelector('#CartDrawer-CartItems');

    if (!freshInner || !currentItems || !currentCartItems || !freshCartItems) return false;

    const savedScrollTop = currentItems.scrollTop || 0;
    const currentRecommendations = currentCartItems.querySelector(RECOMMENDATIONS_SELECTOR);
    const currentViewport = currentRecommendations?.querySelector(VIEWPORT_SELECTOR);
    const savedRecommendationsLeft = currentViewport?.scrollLeft || 0;

    DATA_SELECTORS.forEach((selector) => copyDataNode(currentCartItems, freshCartItems, selector));
    patchShipping(currentCartItems, freshCartItems, preserveRecommendations);
    patchCartRows(currentCartItems, freshCartItems);
    patchFooter(drawer, freshInner);

    // El contenedor que hace scroll nunca fue reemplazado. Reafirmamos el valor
    // para neutralizar cualquier ajuste de scroll anchoring del navegador.
    currentItems.scrollTop = savedScrollTop;

    const survivingViewport = drawer.querySelector(`${RECOMMENDATIONS_SELECTOR} ${VIEWPORT_SELECTOR}`);
    if (preserveRecommendations && survivingViewport) {
      survivingViewport.scrollLeft = savedRecommendationsLeft;
    }

    return true;
  };

  const replaceWithEmptyDrawer = (drawer, state) => {
    const sectionHtml = state?.sections?.['cart-drawer'];
    const freshInner = parseSection(sectionHtml, '.drawer__inner');
    const currentInner = drawer.querySelector('.drawer__inner');
    if (!freshInner || !currentInner) return false;

    currentInner.innerHTML = freshInner.innerHTML;
    return true;
  };

  const focusWithoutScroll = (element) => {
    if (!(element instanceof HTMLElement)) return;
    try {
      element.focus({ preventScroll: true });
    } catch (_) {
      element.focus();
    }
  };

  const installUpdateQuantity = () => {
    const CartDrawerItems = customElements.get('cart-drawer-items');
    const prototype = CartDrawerItems?.prototype;
    if (!prototype || typeof prototype.updateQuantity !== 'function') return false;
    if (prototype.updateQuantity.GowinSurgicalWrapped) return true;

    const nativeUpdateQuantity = prototype.updateQuantity;

    const surgicalUpdateQuantity = function (line, quantity, event, name, variantId) {
      const drawer = this.closest('cart-drawer');
      if (!drawer) return nativeUpdateQuantity.call(this, line, quantity, event, name, variantId);

      const scrollContainer = this;
      const initialScrollTop = scrollContainer.scrollTop || 0;
      const oldRecommendations = drawer.querySelector(RECOMMENDATIONS_SELECTOR);
      const oldRecommendationsViewport = oldRecommendations?.querySelector(VIEWPORT_SELECTOR);
      const oldRecommendationsLeft = oldRecommendationsViewport?.scrollLeft || 0;
      const isRemoval = Number(quantity) === 0;

      drawer.setAttribute(UPDATE_ATTR, 'true');
      this.enableLoading(line);

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      const eventTarget =
        event?.currentTarget?.matches?.('cart-remove-button') ||
        event?.currentTarget?.closest?.('cart-remove-button')
          ? 'clear'
          : 'change';

      return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
        .then((response) => response.text())
        .then((text) => {
          const state = JSON.parse(text);

          if (state.errors) {
            const quantityElement =
              document.getElementById(`Quantity-${line}`) ||
              document.getElementById(`Drawer-quantity-${line}`);
            if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, state.errors);
            return state;
          }

          this.classList.toggle('is-empty', state.item_count === 0);
          drawer.classList.toggle('is-empty', state.item_count === 0);

          if (state.item_count === 0) {
            replaceWithEmptyDrawer(drawer, state);
          } else {
            const patched = patchNonEmptyDrawer(drawer, state, !isRemoval);
            if (!patched) {
              // Fallback de seguridad únicamente si el HTML esperado no existe.
              const freshInner = parseSection(state?.sections?.['cart-drawer'], '.drawer__inner');
              const currentInner = drawer.querySelector('.drawer__inner');
              if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
            }
          }

          patchIconBubble(state);

          if (state.item_count > 0) {
            // Reconstruir inmediatamente los controles personalizados sobre las filas nuevas.
            document.dispatchEvent(new CustomEvent('gowin:cart-patched', { detail: { line, quantity } }));

            // El mismo scroll container debe seguir vivo en una actualización normal.
            const currentScrollContainer = drawer.querySelector('cart-drawer-items');
            if (currentScrollContainer === scrollContainer) {
              currentScrollContainer.scrollTop = initialScrollTop;

              const survivingRecommendations = drawer.querySelector(RECOMMENDATIONS_SELECTOR);
              const survivingViewport = survivingRecommendations?.querySelector(VIEWPORT_SELECTOR);
              if (!isRemoval && survivingViewport && survivingRecommendations === oldRecommendations) {
                survivingViewport.scrollLeft = oldRecommendationsLeft;
              }
            }

            const newQuantityInput =
              document.getElementById(`Drawer-quantity-${line}`) ||
              drawer.querySelector(`.quantity__input[data-index="${line}"]`);
            const updatedValue = state.items?.[line - 1]?.quantity;
            let message = '';
            if (newQuantityInput && Number.isFinite(Number(updatedValue)) && Number(newQuantityInput.value) !== Number(updatedValue)) {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
            this.updateLiveRegions(line, message);

            // No usar el fallback nativo que enfoca .cart-item__name y desplaza el drawer.
            const neutralFocus = drawer.querySelector('.drawer__header .drawer__close') || drawer.querySelector('.drawer__inner');
            focusWithoutScroll(neutralFocus);

            requestAnimationFrame(() => {
              if (currentScrollContainer === scrollContainer && scrollContainer.isConnected) {
                scrollContainer.scrollTop = initialScrollTop;
              }
            });
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: state,
            variantId,
          });

          return state;
        })
        .catch((error) => {
          console.error('GOWin: error al actualizar la cantidad del carrito.', error);
          this.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          if (this.isConnected) this.disableLoading(line);
          window.setTimeout(() => drawer?.removeAttribute(UPDATE_ATTR), 180);
        });
    };

    surgicalUpdateQuantity.GowinSurgicalWrapped = true;
    surgicalUpdateQuantity.nativeUpdateQuantity = nativeUpdateQuantity;
    prototype.updateQuantity = surgicalUpdateQuantity;
    return true;
  };

  const install = () => {
    installStyles();
    installUpdateQuantity();
  };

  install();

  if (!customElements.get('cart-drawer-items')) {
    customElements.whenDefined('cart-drawer-items').then(installUpdateQuantity);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', install, { once: true })
    : install();

  document.addEventListener('shopify:section:load', install);
})();
